'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var modificatorKeys = ['start', 'center', 'end', 'top', 'middle', 'bottom', 'around', 'between'];

var Row = function Row(_ref) {
  var reverse = _ref.reverse,
      className = _ref.className,
      children = _ref.children,
      other = _objectWithoutProperties(_ref, ['reverse', 'className', 'children']);

  var modificators = ['row'];
  var passingProps = {};
  Object.keys(other).forEach(function (key) {
    if (modificatorKeys.includes(key)) {
      var value = other[key];
      if (value) {
        modificators.push(key + '-' + value);
      }
    } else {
      passingProps[key] = other[key];
    }
  });

  if (reverse) {
    modificators.push('reverse');
  }

  var classes = (0, _classnames2.default)(className, modificators);

  return _react2.default.createElement(
    'div',
    _extends({}, passingProps, { className: classes }),
    children
  );
};

var ModificatorType = _propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg']);

Row.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  reverse: _propTypes2.default.bool,
  start: ModificatorType,
  center: ModificatorType,
  end: ModificatorType,
  top: ModificatorType,
  middle: ModificatorType,
  bottom: ModificatorType,
  around: ModificatorType,
  between: ModificatorType
};

exports.default = Row;


//////////////////
// WEBPACK FOOTER
// ./~/react-flexgrid/lib/Row.js
// module id = 450
// module chunks = 114276838955818